import React, { Component } from "react";
import PageHelmet from "../component/common/Helmet";
import ScrollToTop from 'react-scroll-up';
import { FiChevronUp, FiMapPin, FiClock, FiUsers, FiAward, FiBookOpen, FiHome, FiPhone, FiMail, FiInfo, FiArrowRight, FiImage, FiPlay, FiShoppingCart, FiNavigation } from "react-icons/fi";
import Header from "../component/header/Header";
import Footer from "../component/footer/Footer";

class ExhibitFloor1 extends Component {
    render() {
        return (
            <React.Fragment>
                <PageHelmet pageTitle='นิทรรศการชั้น 1' />
                <Header headertransparent="header--transparent" colorblack="color--black" logoname="logo.webp" />

                {/* Hero Section */}
                <div className="hero-section" style={{
                    background: 'linear-gradient(rgba(0,0,0,0.6), rgba(0,0,0,0.6)), url("/assets/images/singha/floor1/IMG_7829.webp")',
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                    minHeight: '50vh',
                    display: 'flex',
                    alignItems: 'center',
                    position: 'relative'
                }}>
                    <div className="container">
                        <div className="row justify-content-center text-center">
                            <div className="col-lg-8">
                                <h1 className="hero-title" style={{
                                    color: 'white',
                                    fontSize: '3.5rem',
                                    fontWeight: 'bold',
                                    marginBottom: '1rem',
                                    textShadow: '2px 2px 4px rgba(0,0,0,0.7)'
                                }}>
                                    นิทรรศการชั้น 1
                                </h1>
                                <p className="hero-subtitle" style={{
                                    color: 'white',
                                    fontSize: '1.2rem',
                                    opacity: 0.9,
                                    textShadow: '1px 1px 2px rgba(0,0,0,0.7)'
                                }}>
                                    สำรวจประวัติศาสตร์และวิถีชีวิตของชุมชนสิงห์ท่า
                                </p>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Exhibition Overview */}
                <div className="exhibition-overview ptb--50" style={{ backgroundColor: 'white' }}>
                    <div className="container">
                        <div className="row align-items-center">
                            <div className="col-lg-6 col-md-12 mb-4">
                                <div className="exhibition-content">
                                    <h2 className="section-title" style={{
                                        fontSize: '2.5rem',
                                        fontWeight: 'bold',
                                        color: '#242424',
                                        marginBottom: '1.5rem'
                                    }}>
                                        นิทรรศการชั้น 1
                                    </h2>
                                    <p className="description" style={{
                                        color: '#666',
                                        lineHeight: '1.8',
                                        fontSize: '1.5rem',
                                        marginBottom: '2rem'
                                    }}>
                                        ชั้น 1 ของพิพิธภัณฑ์สิงห์ท่า จัดแสดงนิทรรศการที่เล่าเรื่องราวความเป็นมาของชุมชนสิงห์ท่า 
                                        ตั้งแต่ยุคก่อบ้านตั้งเมืองจนถึงการพัฒนาสู่เมืองยศสุนทร และกลายเป็นจังหวัดยโสธรในปัจจุบัน
                                    </p>
                                    <div className="exhibition-stats" style={{
                                        display: 'flex',
                                        gap: '2rem',
                                        flexWrap: 'wrap'
                                    }}>
                                        <div className="stat-item" style={{
                                            textAlign: 'center',
                                            flex: '1',
                                            minWidth: '120px'
                                        }}>
                                            <div className="stat-number" style={{
                                                fontSize: '2.5rem',
                                                fontWeight: 'bold',
                                                color: '#F45354',
                                                marginBottom: '0.5rem'
                                            }}>
                                                4
                                            </div>
                                            <div className="stat-label" style={{
                                                color: '#666',
                                                fontSize: '1 rem'
                                            }}>
                                                ส่วนจัดแสดง
                                            </div>
                                        </div>
                                        <div className="stat-item" style={{
                                            textAlign: 'center',
                                            flex: '1',
                                            minWidth: '120px'
                                        }}>
                                            <div className="stat-number" style={{
                                                fontSize: '2.5rem',
                                                fontWeight: 'bold',
                                                color: '#F45354',
                                                marginBottom: '0.5rem'
                                            }}>
                                                200+
                                            </div>
                                            <div className="stat-label" style={{
                                                color: '#666',
                                                fontSize: '1 rem'
                                            }}>
                                                ปี ประวัติศาสตร์
                                            </div>
                                        </div>
                                        <div className="stat-item" style={{
                                            textAlign: 'center',
                                            flex: '1',
                                            minWidth: '120px'
                                        }}>
                                            <div className="stat-number" style={{
                                                fontSize: '2.5rem',
                                                fontWeight: 'bold',
                                                color: '#F45354',
                                                marginBottom: '0.5rem'
                                            }}>
                                                1
                                            </div>
                                            <div className="stat-label" style={{
                                                color: '#666',
                                                fontSize: '1 rem'
                                            }}>
                                                โรงภาพยนตร์จำลอง
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-6 col-md-12">
                                <div className="exhibition-image" style={{
                                    borderRadius: '20px',
                                    overflow: 'hidden',
                                    boxShadow: '0 20px 40px rgba(0,0,0,0.1)'
                                }}>
                                    <img className="w-100" src="/assets/images/singha/floor1/IMG_7829.webp" alt="นิทรรศการชั้น 1" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Exhibition Sections */}
                <div className="exhibition-sections ptb--50" style={{ backgroundColor: '#f8f9fa' }}>
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                <h2 style={{
                                    fontSize: '2.5rem',
                                    fontWeight: 'bold',
                                    color: '#242424',
                                    marginBottom: '3rem',
                                    textAlign: 'center'
                                }}>
                                    ส่วนจัดแสดง
                                </h2>
                            </div>
                        </div>

                        {/* Section 1 */}
                        <div className="exhibition-section mb-5">
                            <div className="row align-items-center">
                                <div className="col-lg-6 col-md-12 mb-4">
                                    <div className="exhibition-card" style={{
                                        backgroundColor: 'white',
                                        padding: '2.5rem',
                                        borderRadius: '20px',
                                        boxShadow: '0 15px 35px rgba(0,0,0,0.1)',
                                        height: '100%',
                                        transition: 'transform 0.3s ease'
                                    }}
                                    onMouseEnter={(e) => {
                                        e.target.style.transform = 'translateY(-5px)';
                                    }}
                                    onMouseLeave={(e) => {
                                        e.target.style.transform = 'translateY(0)';
                                    }}>
                                        <div className="section-header" style={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            marginBottom: '1.5rem'
                                        }}>
                                            <div className="section-icon" style={{
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                width: '60px',
                                                height: '60px',
                                                backgroundColor: '#F45354',
                                                borderRadius: '50%',
                                                marginRight: '1rem'
                                            }}>
                                                <FiBookOpen style={{ color: 'white', fontSize: '1.5rem' }} />
                                            </div>
                                            <h3 style={{
                                                fontSize: '1.8rem',
                                                fontWeight: 'bold',
                                                color: '#242424',
                                                margin: 0
                                            }}>
                                                ส่วนจัดแสดงที่ 1
                                            </h3>
                                        </div>
                                        <h4 style={{
                                            fontSize: '1.5rem',
                                            fontWeight: 'bold',
                                            color: '#F45354',
                                            marginBottom: '1.5rem'
                                        }}>
                                            เรื่องเล่าเมืองสิงห์ท่า
                                        </h4>
                                        <p style={{
                                            color: '#666',
                                            lineHeight: '1.8',
                                            fontSize: '1.5rem',
                                            margin: 0
                                        }}>
                                            ร่วมค้นหาความหมายของคำว่า สิงห์ท่า และตำนานสิงห์คู่ ที่เป็นต้นกำเนิดของชุมชนในยุคก่อบ้านตั้งเมืองจนถึงการยกบ้านสิงห์ท่าขึ้นเป็นเมืองยศสุนทร ในปี พ.ศ. 2357 และกลายเป็นจังหวัดยโสธร จังหวัดที่ 71 ของประเทศไทย
                                        </p>
                                    </div>
                                </div>
                                <div className="col-lg-6 col-md-12">
                                    <div className="exhibition-image" style={{
                                        borderRadius: '20px',
                                        overflow: 'hidden',
                                        boxShadow: '0 20px 40px rgba(0,0,0,0.1)'
                                    }}>
                                        <img className="w-100" src="/assets/images/singha/floor1/IMG_7876.webp" alt="เรื่องเล่าเมืองสิงห์ท่า" />
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Section 2 */}
                        <div className="exhibition-section mb-5">
                            <div className="row align-items-center">
                                <div className="col-lg-6 col-md-12 mb-4">
                                    <div className="exhibition-image" style={{
                                        borderRadius: '20px',
                                        overflow: 'hidden',
                                        boxShadow: '0 20px 40px rgba(0,0,0,0.1)'
                                    }}>
                                        <img className="w-100" src="/assets/images/singha/out/LINE_ALBUM_2025.5.18_250730_1.jpg" alt="สิงห์ท่าในความคิดถึง" />
                                    </div>
                                </div>
                                <div className="col-lg-6 col-md-12">
                                    <div className="exhibition-card" style={{
                                        backgroundColor: 'white',
                                        padding: '2.5rem',
                                        borderRadius: '20px',
                                        boxShadow: '0 15px 35px rgba(0,0,0,0.1)',
                                        height: '100%',
                                        transition: 'transform 0.3s ease'
                                    }}
                                    onMouseEnter={(e) => {
                                        e.target.style.transform = 'translateY(-5px)';
                                    }}
                                    onMouseLeave={(e) => {
                                        e.target.style.transform = 'translateY(0)';
                                    }}>
                                        <div className="section-header" style={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            marginBottom: '1.5rem'
                                        }}>
                                            <div className="section-icon" style={{
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                width: '60px',
                                                height: '60px',
                                                backgroundColor: '#F45354',
                                                borderRadius: '50%',
                                                marginRight: '1rem'
                                            }}>
                                                <FiPlay style={{ color: 'white', fontSize: '1.5rem' }} />
                                            </div>
                                            <h3 style={{
                                                fontSize: '1.8rem',
                                                fontWeight: 'bold',
                                                color: '#242424',
                                                margin: 0
                                            }}>
                                                ส่วนจัดแสดงที่ 2
                                            </h3>
                                        </div>
                                        <h4 style={{
                                            fontSize: '1.5rem',
                                            fontWeight: 'bold',
                                            color: '#F45354',
                                            marginBottom: '1rem'
                                        }}>
                                            สิงห์ท่าในความคิดถึง
                                        </h4>
                                        <p style={{
                                            color: '#666',
                                            lineHeight: '1.8',
                                            fontSize: '1.5rem',
                                            margin: 0
                                        }}>
                                            จำลองบรรยากาศโรงภาพยนตร์แห่งแรกของจังหวัดยโสธร "ยโสธรภาพยนตร์" ที่ตั้งอยู่ภายในพื้นที่ชุมชน พร้อมฉายภาพยนตร์สารคดีสั้น "สิงห์ท่าในความคิดถึง" เรื่องราวมนต์เสน่ห์ของเมืองเก่าเล่าผ่านผู้อาวุโสในชุมชน โอบล้อมไปด้วยความคิดถึงจากวันวาน
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Section 3 */}
                        <div className="exhibition-section mb-5">
                            <div className="row align-items-center">
                                <div className="col-lg-6 col-md-12 mb-4">
                                    <div className="exhibition-card" style={{
                                        backgroundColor: 'white',
                                        padding: '2.5rem',
                                        borderRadius: '20px',
                                        boxShadow: '0 15px 35px rgba(0,0,0,0.1)',
                                        height: '100%',
                                        transition: 'transform 0.3s ease'
                                    }}
                                    onMouseEnter={(e) => {
                                        e.target.style.transform = 'translateY(-5px)';
                                    }}
                                    onMouseLeave={(e) => {
                                        e.target.style.transform = 'translateY(0)';
                                    }}>
                                        <div className="section-header" style={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            marginBottom: '1.5rem'
                                        }}>
                                            <div className="section-icon" style={{
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                width: '60px',
                                                height: '60px',
                                                backgroundColor: '#F45354',
                                                borderRadius: '50%',
                                                marginRight: '1rem'
                                            }}>
                                                <FiNavigation style={{ color: 'white', fontSize: '1.5rem' }} />
                                            </div>
                                            <h3 style={{
                                                fontSize: '1.8rem',
                                                fontWeight: 'bold',
                                                color: '#242424',
                                                margin: 0
                                            }}>
                                                ส่วนจัดแสดงที่ 3
                                            </h3>
                                        </div>
                                        <h4 style={{
                                            fontSize: '1.5rem',
                                            fontWeight: 'bold',
                                            color: '#F45354',
                                            marginBottom: '1rem'
                                        }}>
                                            ลัดเลาะรอบเมือง
                                        </h4>
                                        <p style={{
                                            color: '#666',
                                            lineHeight: '1.8',
                                            fontSize: '1.5rem',
                                            margin: 0
                                        }}>
                                            ทำความรู้จักพื้นที่ชุมชนบ้านสิงห์ท่าผ่าน Mapping Interactive ใน 3 หัวข้อเรื่องได้แก่ รู้จักสิงห์ท่า, แผนที่พัฒนาเมืองและปักหมุดสิงห์ท่า เพื่อให้ผู้เข้าชมได้ทำความรู้จักพื้นที่ชุมชนบ้านสิงห์ท่าในทุกแง่มุม
                                        </p>
                                    </div>
                                </div>
                                <div className="col-lg-6 col-md-12">
                                    <div className="exhibition-image" style={{
                                        borderRadius: '20px',
                                        overflow: 'hidden',
                                        boxShadow: '0 20px 40px rgba(0,0,0,0.1)'
                                    }}>
                                        <img className="w-100" src="/assets/images/singha/floor1/IMG_7887.webp" alt="ลัดเลาะรอบเมือง" />
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Section 4 */}
                        <div className="exhibition-section">
                            <div className="row align-items-center">
                                <div className="col-lg-6 col-md-12 mb-4">
                                    <div className="exhibition-image" style={{
                                        borderRadius: '20px',
                                        overflow: 'hidden',
                                        boxShadow: '0 20px 40px rgba(0,0,0,0.1)'
                                    }}>
                                        <img className="w-100" src="/assets/images/singha/floor1/IMG_7842.webp" alt="สิงห์ท่าค้าขาย" />
                                    </div>
                                </div>
                                <div className="col-lg-6 col-md-12">
                                    <div className="exhibition-card" style={{
                                        backgroundColor: 'white',
                                        padding: '2.5rem',
                                        borderRadius: '20px',
                                        boxShadow: '0 15px 35px rgba(0,0,0,0.1)',
                                        height: '100%',
                                        transition: 'transform 0.3s ease'
                                    }}
                                    onMouseEnter={(e) => {
                                        e.target.style.transform = 'translateY(-5px)';
                                    }}
                                    onMouseLeave={(e) => {
                                        e.target.style.transform = 'translateY(0)';
                                    }}>
                                        <div className="section-header" style={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            marginBottom: '1.5rem'
                                        }}>
                                            <div className="section-icon" style={{
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                width: '60px',
                                                height: '60px',
                                                backgroundColor: '#F45354',
                                                borderRadius: '50%',
                                                marginRight: '1rem'
                                            }}>
                                                <FiShoppingCart style={{ color: 'white', fontSize: '1.5rem' }} />
                                            </div>
                                            <h3 style={{
                                                fontSize: '1.8rem',
                                                fontWeight: 'bold',
                                                color: '#242424',
                                                margin: 0
                                            }}>
                                                ส่วนจัดแสดงที่ 4
                                            </h3>
                                        </div>
                                        <h4 style={{
                                            fontSize: '1.5rem',
                                            fontWeight: 'bold',
                                            color: '#F45354',
                                            marginBottom: '1rem'
                                        }}>
                                            สิงห์ท่าค้าขาย
                                        </h4>
                                        <p style={{
                                            color: '#666',
                                            lineHeight: '1.8',
                                            fontSize: '1.5rem',
                                            margin: 0
                                        }}>
                                            เพื่อให้เข้าถึงเอกลักษณ์ของชุมชนศูนย์กลางการค้าขายกันมาตั้งแต่อดีต ผู้เข้าชมสามารถซื้อหาของที่ระลึกของพิพิธภัณฑ์สิงห์ท่าและสินค้าจากชุมชนในจังหวัดยโสธร รวมไปถึงประสบการณ์ซื้อสินค้าจากอดีตในรูปแบบการ Shopping Online เพื่อเช่ื่อมต่อโลกอดีตและโลกปัจจุบันที่นิทรรศการชั้น 2
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>


                <div className="backto-top">
                    <ScrollToTop showUnder={160}>
                        <FiChevronUp />
                    </ScrollToTop>
                </div>
                <Footer />
            </React.Fragment>
        )
    }
}
export default ExhibitFloor1;
